import http, {RequestOptions, unwrap} from "@/api/http";
import {OrderDto, Page} from "@/api/types";

export interface ListOrdersParams {
    /** Order name including the `#`, e.g. `"#1234"`. Encoded as `%231234` by the params serialiser. */
    name?: string;
    /** Only orders created at or after this instant. */
    from?: string | Date;
    /** Zero-based. */
    page?: number;
    /** At most 100. */
    size?: number;
}

/** `GET /api/orders?name=&from=&page=&size=` (#13, admin) */
export const listOrders = (params: ListOrdersParams = {}, options?: RequestOptions): Promise<Page<OrderDto>> =>
    http.get<Page<OrderDto>>("/orders", {...options, params}).then(unwrap);
